
import { defineComponent, computed } from 'vue'
export default defineComponent({
  name: 'ClientShutDownModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    }
  },
  emits: ['closeClientModal', 'shutDownTer'],
  setup (props, context) {
    const modalVisiable = computed(() => props.show)
    return {
      modalVisiable,
      closeModal () {
        context.emit('closeClientModal', 'MODAL_CLIENT_SHUTDOWN')
      },
      shutDownTerminal () {
        context.emit('shutDownTer')
        context.emit('closeClientModal', 'MODAL_CLIENT_SHUTDOWN')
      }
    }
  }
})
